import { defineMessages } from '../define';

/** Songs to practise at an event ("Lög æfingarinnar"), the quick menu ("Æfing dagsins") and the program editor. */
export const practice = defineMessages(
  {
    'practice.today': 'Æfing dagsins',
    'practice.next': 'Næsta æfing',
    'practice.button_aria': 'Lög æfingarinnar: {title}, {when}',
    'practice.when_today': 'Í dag kl. {time}',
    'practice.when_day': '{day} kl. {time}',
    'practice.songs_title': 'Lög æfingarinnar',
    'practice.count': { one: '{count} lag', other: '{count} lög' },
    'practice.empty': 'Engin lög hafa verið valin fyrir þessa æfingu.',
    'practice.empty_editor': 'Veldu lögin sem á að æfa: stök lög, heilar möppur eða lagalista.',
    'practice.edit': 'Breyta lögum',
    'practice.choose': 'Velja lög',
    'practice.open_first': 'Opna fyrsta lag',
    'practice.open_event': 'Opna æfinguna',
    'practice.current': 'Opið núna',
    'practice.unknown_song': 'Lag sem þú sérð ekki',
    'practice.unknown_list': 'Listi sem fannst ekki',
    'practice.nothing_visible': 'Ekkert lag sem þú sérð',
    'practice.on_program': 'Á æfingunni',
    'practice.on_program_empty': 'Ekkert valið enn. Bættu við lögum, möppum eða lagalistum hér fyrir neðan.',
    'practice.add_title': 'Bæta við',
    'practice.search': 'Leita að lagi, möppu eða lagalista',
    'practice.setlists': 'Lagalistar',
    'practice.folders': 'Möppur',
    'practice.songs': 'Lög',
    'practice.no_results': 'Ekkert fannst',
    'practice.add_aria': 'Bæta „{name}“ við',
    'practice.added_aria': '„{name}“ er á æfingunni',
    'practice.remove_aria': 'Fjarlægja „{name}“',
    'practice.up_aria': 'Færa „{name}“ upp',
    'practice.down_aria': 'Færa „{name}“ niður',
    'practice.whole_list': 'Allur listinn · {count}',
    'practice.saved': 'Lög æfingarinnar vistuð',
    'practice.max_items': 'Í mesta lagi {max} atriði á æfingu.',
  },
  {
    'practice.today': "Today's practice",
    'practice.next': 'Next practice',
    'practice.button_aria': 'Songs to practise: {title}, {when}',
    'practice.when_today': 'Today at {time}',
    'practice.when_day': '{day} at {time}',
    'practice.songs_title': 'Songs to practise',
    'practice.count': { one: '{count} song', other: '{count} songs' },
    'practice.empty': 'No songs have been chosen for this practice.',
    'practice.empty_editor': 'Choose the songs to practise: single songs, whole folders or setlists.',
    'practice.edit': 'Edit songs',
    'practice.choose': 'Choose songs',
    'practice.open_first': 'Open the first song',
    'practice.open_event': 'Open the practice',
    'practice.current': 'Open now',
    'practice.unknown_song': 'A song you cannot see',
    'practice.unknown_list': 'A list that was not found',
    'practice.nothing_visible': 'No song you can see',
    'practice.on_program': 'On the programme',
    'practice.on_program_empty': 'Nothing chosen yet. Add songs, folders or setlists below.',
    'practice.add_title': 'Add',
    'practice.search': 'Search songs, folders or setlists',
    'practice.setlists': 'Setlists',
    'practice.folders': 'Folders',
    'practice.songs': 'Songs',
    'practice.no_results': 'Nothing found',
    'practice.add_aria': 'Add “{name}”',
    'practice.added_aria': '“{name}” is on the programme',
    'practice.remove_aria': 'Remove “{name}”',
    'practice.up_aria': 'Move “{name}” up',
    'practice.down_aria': 'Move “{name}” down',
    'practice.whole_list': 'Whole list · {count}',
    'practice.saved': 'Songs to practise saved',
    'practice.max_items': 'At most {max} items per practice.',
  },
);
